import React from 'react';
import { observer } from 'mobx-react';
import { EventHubFormVM } from './event-hub-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../global/sub-window/common/common-close-sub-window-buttons';
import { ADD_TEXT, APPLY_TEXT, cancelText, MORE_BUTTON_TEXT } from '../../../constants/common-labels.constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormFieldInput } from '../../global/form/form-field-input/form-field-input';
import { EventHubFormField, FORM_CONFIG } from './event-hub-form.config';
import OptionsButton, { IButtonOption } from '../../global/options-button/options-button';
import { DELETE_HUB_TEXT } from '../event-hubs.text';

type EventHubFormPresentationProps = {
    vm: EventHubFormVM;
};
export const EventHubFormPresentation = observer(({ vm }: EventHubFormPresentationProps): JSX.Element => {
    const intl = useIntl();

    const { eventHubName } = vm.getFormFields();

    const submitButtonText = vm.isEditMode ? intl.formatMessage(APPLY_TEXT) : intl.formatMessage(ADD_TEXT);

    const moreOptions: IButtonOption[] = [
        vm.isEditMode && vm.hasDeletePermission && {
            label: intl.formatMessage(DELETE_HUB_TEXT),
            action: vm.showDeleteHubConfirmation,
            danger: true,
        },
    ].filter(Boolean);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form event-hub-form'>
                    <FormFieldInput.Text
                        field={eventHubName}
                        labelDescriptor={FORM_CONFIG[EventHubFormField.EVENT_HUB_NAME].labelDescriptor}
                        withError
                    />
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={submitButtonText}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.submitForm}
                        disabled={vm.isLoading}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                    {!!moreOptions.length && <OptionsButton
                        className='options-button--right-margin-auto'
                        modifier={['fat', 'options']}
                        label={<FormattedMessage {...MORE_BUTTON_TEXT} />}
                        options={moreOptions}
                        position='top'
                        align='start'
                    />}
                </div>
            }
        />
    );
});

